$.fn.hashTabs = function () {
    var context = this;

    // Show the tab corresponding with the hash in the URL, or the first tab.
    var showTabFromHash = function () {
        var tab = getHashParams().tab,
            smooth = false;//s[0];window.location.hash;
        if (!tab || tab.length > 100) return;
        if ($(tab).parent().hasClass('f-toggle-content')) {
            tab = $(tab).parents('.f-tabs-content__item').attr('id');
            tab = '#' + tab;
            smooth = true;
        }
        var selector = tab ? 'a[href="' + tab + '"]' : 'li.active > a';
        $(selector, context).tab('show');
        syncTabs(tab);
        if (smooth) {
            setTimeout(function () {
                $.scrollTo('.f-tabs-content__item.active .f-toggle', 500, {
                    offset: -100,
                    easing: 'easeOutExpo'
                });
            }, 500);
        }
    }

    var syncTabs = function (tab) {
        tab = tab.split('#')[1] || tab;
        $('[data-tab-sync=' + tab + ']').each(function () {
            $(this).tab('show');
        });
    };

    //ScrollTo
    var scrollToTab = function (offset, speed, target) {
        $.scrollTo(target, speed, {
            offset: -offset,
            easing: 'easeOutExpo'
        });
    }

    // Set the correct tab when the page loads
    showTabFromHash(context);

    // Set the correct tab when a user uses their back/forward button
    $(window).on('hashchange', showTabFromHash);


    window.addSearchChangedEventListener(showTabFromHash);
    // Change the URL when tabs are clicked
    $('a', context).on('click', function (e) {
        var $this = $(this),
            hash = this.href.split('#')[1],
            tabs = $this.closest('.f-tabs--fixed'),
            content = tabs.data('target') ? $(tabs.data('target')) : $('.f-tabs-content'),
            offset = tabs.outerHeight(),
            contentPos = content.offset().top,
            currentPos = $(window).scrollTop() - offset,
            timeout = 500;
        if (!$this.data('tab-sync')) {
            changeTab(hash);
            syncTabs(hash);
        }

        if (contentPos < currentPos) {
            scrollToTab(offset, timeout, content);
            $this.data('triggered', true);
            setTimeout(function () {
                if ($this.data('triggered')) {
                    $this.tab('show').data('triggered', false);
                }
                ;
            }, timeout);
            //e.preventDefault();
            return false;
        }
    });

    return this;
};

;(function ($) {
    'use strict';
    $('.b-tabs').hashTabs();

    $('[data-assist="tab"]').on('click', function () {
        var target = $(this).attr('href');
        $('a[href="' + target + '"][data-toggle="tab"]').trigger('click');
    });

    var activeTab = $('[data-toggle="tab"].active');

    if (activeTab.length) {
        activeTab[0].scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
    }

    $(document).on('show.bs.tab', '[data-toggle="tab"]', function (e) {
        var currentLayout = document.body.dataset.layout,
            nextLayout = e.target.dataset.layout;

        if (nextLayout && currentLayout !== nextLayout) {
            e.preventDefault();
            window.location.replace(e.target.href);
            window.location.reload();
        } else {
            e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
    });
})(jQuery);
